import { isFunction, isWindow } from './type'

/**
 * 防抖函数
 * @param {Function} fn
 * @param {Number} delay
 * @param  {...any} args
 * @returns {Function}  该Function是防抖之后的fn
 */
export function debounce(fn, delay = 1000, ...args) {
    if (!isFunction(fn)) throw new Error(`${fn}不是一个函数，请传入一个函数进行防抖`)
    const _this = this // call apply执行该防抖函数，保存_this
    let timer = null
    return function(..._args) {
        timer && clearTimeout(timer)
        timer = setTimeout(() => {
            // 如果返回的函数改变了this指向，就用该this，否则使用debounce的this
            fn.apply(isWindow(this) ? _this : this, args.concat(_args))
        }, delay)
    }
}

// 立即执行防抖函数
export function debounceImmediate(func, delay, immediate){
    var timer = null;
    return function(){
        var context = this;
        var args = arguments;
        if(timer) clearTimeout(timer);
        if(immediate){
            //根据距离上次触发操作的时间是否到达delay来决定是否要现在执行函数
            var doNow = !timer;
            //每一次都重新设置timer，就是要保证每一次执行的至少delay秒后才可以执行
            timer = setTimeout(function(){
                timer = null;
            },delay);
            //立即执行
            if(doNow){
                func.apply(context,args);
            }
        }else{
            timer = setTimeout(function(){
                func.apply(context,args);
            },delay);
        }
    }
}